import { EventManager } from './EventManager';

export type AppStatus = 'uninitialized' | 'initializing' | 'running' | 'paused' | 'stopped' | 'error';

export class SystemState {
    private _status: AppStatus = 'uninitialized';
    private _errorMessages: string[] = [];
    protected _eventManager: EventManager;

    constructor(eventManager: EventManager) {
        this._eventManager = eventManager;
    }

    public get status(): AppStatus {
        return this._status;
    }
    
    public get errorMessages(): string[] {
        return [...this._errorMessages];
    }
    
    public isRunning(): boolean {
        return this._status === 'running';
    }
    
    public isPaused(): boolean {
        return this._status === 'paused';
    }
    
    public hasError(): boolean {
        return this._status === 'error';
    }

    public setStatus(newStatus: AppStatus): void {
        if (this._status === newStatus) return;
        
        const oldStatus = this._status;
        this._status = newStatus;
        
        if (newStatus !== 'error') {
            this._errorMessages = [];
        }
        
        ////console.log(`System status changed from ${oldStatus} to ${newStatus}`);
        this._eventManager.emit('system:status-changed', { newStatus, oldStatus });
    }
    
    public addError(message: string): void {
        this._errorMessages.push(message);
        this.setStatus('error');
        this._eventManager.emit('system:error-added', { message });
    }
} 